export default "__VITE_ASSET__DTeuS9rX__"